import { api } from '@services/apiService';
import handleRawApiError from '@utils/fetch/handleRawApiError';
import { billingAlgunaCheckoutSession } from '@utils/resources/billing';

import {
  AlgunaCheckoutConfirmation,
  AlgunaCheckoutOptions,
  AlgunaCheckoutPlan,
  AlgunaCheckoutSession,
} from './types';

/**
 * The API sells Pro as an upgrade, and any other plan as an add-on, which
 * names its plan alongside its setup options
 */
const checkoutSessionBody = (
  plan: AlgunaCheckoutPlan,
  options?: AlgunaCheckoutOptions
) =>
  plan === 'pro'
    ? { type: 'upgrade' }
    : { type: 'add-on', options: { ...options, plan } };

export const createAlgunaCheckoutSession: (
  teamUuid: string,
  plan: AlgunaCheckoutPlan,
  options?: AlgunaCheckoutOptions
) => Promise<AlgunaCheckoutSession> = handleRawApiError(
  (
    teamUuid: string,
    plan: AlgunaCheckoutPlan,
    options?: AlgunaCheckoutOptions
  ) =>
    api
      .post(billingAlgunaCheckoutSession(teamUuid), {
        json: checkoutSessionBody(plan, options),
      })
      .json<AlgunaCheckoutSession>()
);

export const confirmAlgunaCheckoutSession: (
  teamUuid: string,
  sessionId: string
) => Promise<AlgunaCheckoutConfirmation> = handleRawApiError(
  (teamUuid: string, sessionId: string) =>
    api
      .put(billingAlgunaCheckoutSession(teamUuid), { json: { sessionId } })
      .json<AlgunaCheckoutConfirmation>()
);
